import React, { useEffect, useState } from "react";
import { breadcrumbsMapping } from "../../../services/breadcrumbsMapping";
import "jspdf-autotable";
import "./CashCollectionView.scss";
import {
  getComponentTexts,
  getDateAndTime,
  renderPriceWithSymbol,
} from "../../../services/commonMethods";
import Breadcrumbs from "../../components/Breadcrumbs";
import CardContainer from "../../components/CardContainer";
import { connect, useDispatch } from "react-redux";
import {
  Grid,
  InputAdornment,
  List,
  ListItem,
  TableCell,
} from "@material-ui/core";
import {
  CURRENCIES,
  DEFAULT_VALUES,
  PURCHASE_ORDER_STATUSES,
  RUPEE_NOTE,
} from "../../../constants";
import PropTypes from "prop-types";
import CustomInput from "pages/components/Input";
import CustomButton from "pages/components/Button";
import {
  requestCashCollection,
  resetCashCollection,
} from "modules/actions/cashCollectionView.action";
import { API_ROUTES, API_ROUTES_KEY } from "constants/apiRoutes";
import { errorToast, successToast } from "modules/actions/toast.action";
import { webApiCheck } from "services/gatekeeperMethods";
import { postDashboardWebApi } from "webApis/apiResource";
import { getAccessToken } from "services/browserStorage";
import { API_ACTIONS } from "constants/apiRequestData";
import CustomNewTable from "pages/components/NewTable";
import LinkWrapper from "pages/components/LinkWrapper";
import { backdropClasses } from "@mui/material";

function CashCollectionView({
  match,
  requestCashCollection,
  resetCashCollection,
  cashCollection,
  history,
}) {
  const [state, setState] = useState(0);
  const [tableData, setTableData] = useState([]);
  const cashCollectionId = parseInt(match.params.id);

  //Texts to be shown on Cash Collection overview page.
  const componentTexts = getComponentTexts(
    "cash_collection.cash_collection_overview"
  );

  const tableHead = (function () {
    let columnNames = componentTexts.table_column_names;
    return columnNames.map((column) => ({ title: column }));
  })();

  const directSaleTableHead = (function () {
    let columnNames = componentTexts.direct_sale_table_column_names;
    return columnNames.map((column) => ({ title: column }));
  })();

  const CASH_COLLECTION_STATUSES = (state) => {
    switch (state) {
      case "SUBMITTED":
        //blue
        return "#2F80ED";
      case "RECEIVED":
        //green
        return "#27AE60";
      default:
        return;
    }
  };

  const dispatchActions = useDispatch();

  const handleRecieve = async () => {
    const response = await postDashboardWebApi(
      getAccessToken(),
      API_ROUTES[API_ROUTES_KEY.GET_CASH_COLLECTION],
      {
        payload: {
          action: API_ACTIONS[API_ROUTES_KEY.RECEIVE_CASH_IN_HAND_ORDER],
          id: parseInt(cashCollectionId),
          receive_amt: parseInt(state),
        },
      }
    );
    if (webApiCheck(response)) {
      dispatchActions(
        successToast({
          message: "Recieved executed successfully",
        })
      );
      let payload = {
        action: API_ACTIONS[API_ROUTES_KEY.GET_CASH_IN_HAND_ORDER],
        id: cashCollectionId,
      };
      let endPointUrl = API_ROUTES[API_ROUTES_KEY.GET_CASH_COLLECTION];
      requestCashCollection(endPointUrl, { payload });
    }
  };
  const handleInput = (ev) => {
    setState(parseInt(ev.target.value) > 0 ? parseInt(ev.target.value) : 0);
  };

  useEffect(() => {
    let payload = {
      action: API_ACTIONS[API_ROUTES_KEY.GET_CASH_IN_HAND_ORDER],
      id: cashCollectionId,
    };
    let endPointUrl = API_ROUTES[API_ROUTES_KEY.GET_CASH_COLLECTION];
    requestCashCollection(endPointUrl, { payload });
    return resetCashCollection;
  }, []);

  useEffect(() => {
    setState(parseInt(cashCollection?.submitted_amount));
  }, [cashCollection]);

  useEffect(() => {
    let nextTableData = [];
    if (cashCollection.id) {
      //Renders table content.
      // cashCollection.map((product) => {
      cashCollection?.CashCollectionOrders?.map((order) => {
        let tableRow = {
          order_id: (
            <LinkWrapper to={`/view-cash-order/${order.id}`}>
              {order?.order_id || DEFAULT_VALUES.DOUBLE_DASH}
            </LinkWrapper>
          ),
          vm: (
            <TableCell>
              <span>
                {order?.VendingMachine?.name || DEFAULT_VALUES.DOUBLE_DASH}
              </span>
            </TableCell>
          ),
          expected_amount: (
            <TableCell>
              <span>
                {order.expected_amount
                  ? renderPriceWithSymbol(
                      Math.round(order?.expected_amount?.toFixed(2))
                    )
                  : DEFAULT_VALUES.DOUBLE_DASH}
              </span>
            </TableCell>
          ),
          pickedup_amount: (
            <TableCell>
              <span>
                {order?.picked_up_amount
                  ? renderPriceWithSymbol(
                      Math.round(order?.picked_up_amount?.toFixed(2))
                    )
                  : DEFAULT_VALUES.DOUBLE_DASH}
              </span>
            </TableCell>
          ),
        };
        nextTableData.push(tableRow);
      });

      cashCollection?.SaleOrders?.map((order) => {
        let tableRow = {
          id: (
            <TableCell>
              {order?.order_id || DEFAULT_VALUES.DOUBLE_DASH}
            </TableCell>
          ),
          amount: (
            <TableCell>
              <span>
                {order?.amount
                  ? renderPriceWithSymbol(Math.round(order?.amount.toFixed(2)))
                  : DEFAULT_VALUES.DOUBLE_DASH}
              </span>
            </TableCell>
          ),
          refund_amount: (
            <TableCell>
              <span>
                {order?.refund_amount
                  ? renderPriceWithSymbol(
                      Math.round(order?.refund_amount.toFixed(2))
                    )
                  : DEFAULT_VALUES.DOUBLE_DASH}
              </span>
            </TableCell>
          ),
          date: (
            <TableCell>
              <span>
                {getDateAndTime(order?.created_at) ||
                  DEFAULT_VALUES.DOUBLE_DASH}
              </span>
            </TableCell>
          ),
        };
        nextTableData.push(tableRow);
      });
    }
    return setTableData(nextTableData);
  }, [cashCollection]);

  return (
    <div className="purchase-order-manage-view">
      <React.Fragment>
        <Breadcrumbs data={breadcrumbsMapping(match.path)} />
        <CardContainer title={componentTexts.page_title}>
          <Grid style={{ marginTop: "1rem" }} container>
            <Grid item lg={12}>
              <Grid container spacing={2}>
                <Grid item lg={3} md={6} className="view-top-details">
                  <label>{componentTexts.list_rows_text.order_id}</label>
                  <span className="name">
                    {cashCollection?.order_id || DEFAULT_VALUES.DOUBLE_DASH}
                  </span>
                </Grid>

                <Grid item lg={3} md={6} className="view-top-details">
                  <label>{componentTexts.list_rows_text.source}</label>
                  <span className="name">
                    {cashCollection?.RefillPartner?.name ||
                      DEFAULT_VALUES.DOUBLE_DASH}
                  </span>
                </Grid>

                <Grid item lg={3} md={6} className="view-top-details">
                  <label>{componentTexts.list_rows_text.created_at}</label>
                  <span className="name">
                    {getDateAndTime(cashCollection?.created_at) ||
                      DEFAULT_VALUES.DOUBLE_DASH}
                  </span>
                </Grid>

                <Grid item lg={3} md={6} className="view-top-details">
                  <label>{componentTexts.list_rows_text.status}</label>
                  <span
                    style={{
                      color: CASH_COLLECTION_STATUSES(cashCollection?.state),
                    }}
                  >
                    {cashCollection?.state || DEFAULT_VALUES.DOUBLE_DASH}
                  </span>
                </Grid>

                <Grid item lg={3} md={6} className="view-top-details">
                  <label>{componentTexts.list_rows_text.destination}</label>
                  <span
                    className="name cursor-pointer"
                    onClick={() =>
                      history.push(
                        `/warehouse/${cashCollection?.Warehouse?.id}`
                      )
                    }
                  >
                    {cashCollection?.Warehouse?.name ||
                      DEFAULT_VALUES.DOUBLE_DASH}
                  </span>
                </Grid>

                <Grid item lg={3} md={6} className="view-top-details">
                  <label>{componentTexts.list_rows_text.last_updated}</label>
                  <span className="name">
                    {getDateAndTime(cashCollection?.end_date) ||
                      DEFAULT_VALUES.DOUBLE_DASH}
                  </span>
                </Grid>

                <Grid item lg={3} md={6} className="view-top-details">
                  <label style={{ marginTop: "0.5rem" }}>
                    {/* {componentTexts.list_rows_text.calculation_time} */}
                    Total Cash:
                  </label>
                  {/* <span className="name">{DEFAULT_VALUES.DOUBLE_DASH}</span> */}
                  <span className="name">{`${CURRENCIES.RUPEES} ${
                    cashCollection?.submitted_amount
                      ? Math.round(cashCollection?.submitted_amount).toFixed(2)
                      : DEFAULT_VALUES.DOUBLE_DASH
                  }`}</span>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <h5 style={{ marginTop: "2rem" }}>Cash Collection</h5>
          <Grid container style={{ width: "100%", marginTop: "1rem" }}>
            <CustomNewTable
              tableHead={tableHead}
              tableData={tableData}
              refr="cash_in_hand-order-table"
            />
          </Grid>

          <h5 style={{ marginTop: "2rem" }}>Direct Sale</h5>
          <Grid container style={{ width: "100%", marginTop: "1rem" }}>
            <CustomNewTable
              tableHead={directSaleTableHead}
              tableData={tableData}
              refr="direct-sale-table"
            />
          </Grid>
        </CardContainer>
        {
          cashCollection?.state != "RECEIVED" && (
            <div style={{ paddingLeft: "25px" }}>
              <CustomButton
                type="button"
                btnProps={{
                  variant: "contained",
                  text: "Recieve",
                  className: "view-button-new  view-button-save mr-2 mb-2",
                  onClick: () => handleRecieve(),
                }}
              />
            </div>
          )
          // :
          // ""
        }
      </React.Fragment>
    </div>
  );
}

CashCollectionView.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  cashCollection: state.cashCollectionView.data,
});

const mapDispatchToProps = (dispatch) => ({
  requestCashCollection: (urlEndPoint, payload) =>
    dispatch(requestCashCollection(urlEndPoint, payload)),
  resetCashCollection: () => dispatch(resetCashCollection()),
  showErrorToast: (obj) => dispatch(errorToast(obj)),
  showSuccessToast: (obj) => dispatch(successToast(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CashCollectionView);
